import { FC, useEffect, useState } from 'react'
import { Guid } from '../../../api/baseApi';
import { ChannelSystemType, cloneTVProfile, createTVChannelMapping, createTVProfile, deleteTVChannelMapping, deleteTVProfile, getTVChannelMappings, getTVChannels, getTVProfiles, TVChannel, TVChannelMapping, TVChannelMappingCreateRequest, TVChannelMappingUpdateRequest, TVProfile, TVProfileRequest, updateTVChannelMapping, updateTVProfile } from '../../../api/tvChannelApi';
import { Button } from '../Button';
import { FormInput, FormRow } from '../formRow/FormRow';
import GlobalSpinner from '../globalsSpinner/GlobalSpinner'
import IconButton from '../iconButton/IconButton';
import { CenterModal, RightModal, SmallModal } from '../sideModal/Modal';
import Select, { SingleValue } from 'react-select';
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from '../tab/Tab';
import SvgSelector from '../svgSelector/SvgSelector';

type ModalAction = "create" | "edit" | "nothing";

const skyQCommands = ["power",
"select", 
"backup",
"dismiss",
"channelup",
"channeldown",
"interactive",
"sidebar",
"help",
"services",
"search",
"tvguide",
"home",
"i",
"text", 
"up",
"down", 
"left",
"right",
"red",
"green",
"yellow",
"blue",
"0",
"1",
"2", 
"3",
"4",
"5",
"6",
"7",
"8",
"9",
"play",
"pause",
"stop",
"record",
"fastforward",
"rewind", 
"boxoffice", 
"sky"]

const TvChannelsMapping:FC = () => {
    let [isLoading, setIsLoading] = useState(false);

    let [tvChannelsList, setTvChannelsList] = useState<TVChannel[]>([]);
    let [tvProfilesList, setTvProfilesList] = useState<TVProfile[]>([]);
    let [tvProfileName, setTvProfileName] = useState("");
    let [isTvProfileNameError, setIsTvProfileNameError] = useState(false);

    let [mappingsList, setMappingList] = useState<TVChannelMapping[]>([]);
    let [mappingIdForAction, setMappingIdForAction] = useState<Guid>('');
    let [isShowDeleteMappingModal, setIsShowDeleteMappingModal] = useState(false);

    let [command, setCommand] = useState('');
    let [isCommandError, setIsCommandError] = useState(false);
    let [commandErrorMessage, setCommandErrorMessage] = useState('');

    let [selectedTvChannel, setSelectedTvChannel] = useState<SingleValue<TVChannel>>(null);
    let [isSelectedTvChannelError, setIsSelectedTvChannelError] = useState(false);
    
    let [isShowDeleteTvProfileModal, setIsShowDeleteTvProfileModal] = useState(false);
    let [tvProfileIdForAction, setTvProfileIdForAction] = useState<Guid>('');
    
    let [modalAction, setModalAction] = useState<ModalAction>("nothing");

    let [isShowProfileModal, setIsShowProfileModal] = useState(false);
    let [isShowMappingModal, setIsShowMappingModal] = useState(false);
    let [isShowSkyQCommandModal, setIsShowSkyQCommandModal] = useState(false);

    

    useEffect(()=>{

        async function fetchData() {
            setIsLoading(true);
            await Promise.all([updateTvProfileList(),updateTVChannelList()])
            setIsLoading(false);
        }
        
        fetchData()
    },[]);
    
    useEffect(()=> {
        async function fetchData() {
            setIsLoading(true);
            await updateMappingsList();
            setIsLoading(false);
        }

        fetchData()
    },[tvProfileIdForAction])

    const updateTvProfileList = async () => {
        let response = await getTVProfiles();
        if( response.type === "succes") {
            setTvProfilesList(response.data.items);
            let activeProfile = response.data.items.find(it => it.id == tvProfileIdForAction);
            if(!activeProfile){
                if(response.data.items.length){
                    setTvProfileIdForAction(response.data.items[0].id);
                } 
                else setTvProfileIdForAction("");
            } 
        }
    }

    const updateTVChannelList = async () => {
        let response = await getTVChannels();
        if( response.type === "succes") {
            setTvChannelsList(response.data.items);
        }
    }

    const updateMappingsList = async () => {
        if(tvProfileIdForAction){
            let response = await getTVChannelMappings(tvProfileIdForAction);
            if( response.type === "succes") {
                setMappingList(response.data.items);
            }
        }
    }

    const showTvProfileModal = (action: ModalAction, tvProfile?: TVProfile) => {
        setIsShowProfileModal(true);
        setModalAction(action);
        if(tvProfile){
            setTvProfileIdForAction(tvProfile.id);
            setTvProfileName(tvProfile.name);
        }
    }

    const hideTvProfileModal = () => {
        setIsShowProfileModal(false);
        setModalAction("nothing");
        setTvProfileName('');
        setIsTvProfileNameError(false);
    }

    const createOrUpdateTvProfile = async () => {
        let isValid = true;

        if(!!!tvProfileName){
            setIsTvProfileNameError(true);
            isValid = false;
        }
        
        if(!isValid) return;

        let request:TVProfileRequest = {
            name: tvProfileName,
        }

        setIsLoading(true)
        if( modalAction === "edit" ) {
            await updateTVProfile(tvProfileIdForAction,request)
        }

        if( modalAction === "create" ) {
            let result = await createTVProfile(request);
            if(result.type == "succes"){
                setTvProfileIdForAction(result.data.id)
            }
        }

        setTvProfileName('');
        hideTvProfileModal();
        await updateTvProfileList();
        setIsLoading(false);
    }


    const showDeleteTvProfileModal = () => {
        setIsShowDeleteTvProfileModal(true);
    }

    const hideDeleteTvProfileModal = () => {
        setIsShowDeleteTvProfileModal(false);
    }

    const removeTvProfile = async () => {
        setIsLoading(true);
        await deleteTVProfile(tvProfileIdForAction);
        await updateTvProfileList();
        setIsShowDeleteTvProfileModal(false);
        setIsLoading(false);
    }

    const checkActiveTab = (tab: string) => tab === tvProfileIdForAction;

    const renderTvProfileTabs = (tvProfiles: TVProfile[]) => {
        return tvProfiles.map( (it, index) => {
            return <span key={index} className="d-flex align-items-center">
                {it.tvChannelSystemType !== ChannelSystemType.User && <><SvgSelector title="lock" />&nbsp;</>}
                <TabNavigationElement title={it.name} isActive={checkActiveTab(it.id)} onClick={() => { setTvProfileIdForAction(it.id) }} />
            </span>
        })
    }

    const getActiveProfile = () => tvProfilesList.find( it => it.id === tvProfileIdForAction)

    const isActiveProfileEditable = () => {
        const profile = getActiveProfile();
        return profile ? profile.tvChannelSystemType === ChannelSystemType.User : true;
    }

    const duplicateCurrentTvProfile = async () => {
        setIsLoading(true);
        await cloneTVProfile(tvProfileIdForAction);
        await updateTvProfileList();
        setIsLoading(false);
    }

    const showMappingModal = (action: ModalAction, mappingElement?: TVChannelMapping) => {
        setIsShowMappingModal(true);
        setModalAction(action);
        if(mappingElement){
            let t = tvChannelsList.find(it => it.name === mappingElement.name);
            setMappingIdForAction(mappingElement.id)
            setSelectedTvChannel(t ? t : null)
            setCommand(mappingElement.irCommand)
        }
    }

    const hideMappingModal = () => {
        setIsShowMappingModal(false);
        setMappingIdForAction('');
        setModalAction("nothing");
        setSelectedTvChannel(null);
        setIsSelectedTvChannelError(false);
        setCommand('')
        setIsCommandError(false);
        setCommandErrorMessage("");
    }

    const onSelectedTvChannel = (newValue: SingleValue<TVChannel>) => {
        setSelectedTvChannel(newValue);
        setIsSelectedTvChannelError(false);
    }

    const isCommandAlreadyInUse = (command: string) => {
        return mappingsList.some(it => it.irCommand === command);
    }

    const createOrUpdateTvChannelMapping = async () => {
        let isValid = true;

        if(!selectedTvChannel){
            setIsSelectedTvChannelError(true);
            isValid = false;
        }

        if(!command){
            setIsCommandError(true);
            setCommandErrorMessage("Please enter Command")
            isValid = false;
        }
        if(isCommandAlreadyInUse(command)){
            setIsCommandError(true);
            setCommandErrorMessage("This Command is already in use")
            isValid = false;
        }

        if(!isValid) return;

        setIsLoading(true)
        if( modalAction === "edit" ) {
            let request:TVChannelMappingUpdateRequest = {
                command: command,
            }
            await updateTVChannelMapping(tvProfileIdForAction, mappingIdForAction, request)
        }

        if( modalAction === "create" ) {
            let request:TVChannelMappingCreateRequest = {
                tvChannelId: selectedTvChannel!.id,
                command: command,
            }
            await createTVChannelMapping(tvProfileIdForAction, request)
        }

        await updateMappingsList();
        hideMappingModal();
        setIsLoading(false);
    }

    const showDeleteMappingModal = (id: Guid) => {
        setIsShowDeleteMappingModal(true);
        setMappingIdForAction(id);
    }

    const hideDeleteMappingModal = () => {
        setIsShowDeleteMappingModal(false);
        setMappingIdForAction("");
    }

    const removeMapping = async () => {
        setIsLoading(true);
        await deleteTVChannelMapping(tvProfileIdForAction, mappingIdForAction);
        await updateMappingsList();
        hideDeleteMappingModal();
        setIsLoading(false);
    }

    const isDefaultTvMappingProfileActive = () => {
        let t = tvProfilesList.find(it => it.id === tvProfileIdForAction);
        if(t) {
            return t.isDefault
        }
    }

    const renderMappingsList = (mapping: TVChannelMapping[]) => {
        const editable = isActiveProfileEditable();
        return mapping.map( it => {
           return <tr key={it.id}>
                <td>{it.name}</td>
                <td>{it.irCommand}</td>
                <td>
                    {editable && <IconButton tooltipText="Edit" type="edit" onClick={() => {showMappingModal("edit", it)}} />}
                    {editable && <IconButton tooltipText="Delete" type="delete" onClick={() => {showDeleteMappingModal(it.id)}} />}
                </td>
            </tr>
        })
    }

    const showSkyQCommandModal = () => {
        setIsShowSkyQCommandModal(true);
    }

    const hideSkyQCommandModal = () => {
        setIsShowSkyQCommandModal(false);
    }

    return <>
        <div className="d-flex justify-content-between align-items-center mb-20 w-100">
            <h2>TV Mapping Profiles</h2>
        </div>

        <div className="w-100">
        {tvProfilesList.length === 0 ? <div className="d-flex align-items-center">
            <p>Add new TV Mapping Profile</p> &nbsp;&nbsp;&nbsp;&nbsp;
            <IconButton tooltipText="Add Mapping Profile" type="plus" roundedButton={true} onClick={()=> showTvProfileModal("create")} />
        </div>
         : 
        <Tabs>
            <TabNavigation>
                <>
                    {renderTvProfileTabs(tvProfilesList)}
                </>
                <IconButton tooltipText="Add Mapping Profile" type="plus" roundedButton={true} onClick={()=> {showTvProfileModal("create")}} />
            </TabNavigation>
            <TabsContainer>
                <TabElement isActive={true}>
                    <>
                        <div className="d-flex justify-content-end align-items-center mb-20 w-100">
                            <Button color="green" label="Show SkyQ Command List" onClick={showSkyQCommandModal} />&nbsp;
                            {isActiveProfileEditable() && <><Button color="green" label="Add TV Channel Mapping" onClick={() => {showMappingModal("create")}} />&nbsp;
                            <Button color="green" label="Edit" onClick={() => {showTvProfileModal("edit", getActiveProfile())}} />&nbsp;
                            <Button color="green" label="Duplicate" onClick={duplicateCurrentTvProfile} />&nbsp;
                            <Button color="gray" label="Delete" onClick={showDeleteTvProfileModal} isDisabled={isDefaultTvMappingProfileActive()} /></>}
                        </div>

                        {mappingsList.length ? <table className="table">
                            <thead>
                                <tr>
                                    <td>TV Channel Name</td>
                                    <td>Command</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderMappingsList(mappingsList)}
                            </tbody>
                        </table> : <p>Element list is empty</p>}
                    </>
                </TabElement>
                <></>
            </TabsContainer>
        </Tabs>
        }
        
        </div>

        <RightModal title={modalAction === "edit" ? "Edit TV Mapping Profile" : "Add TV Mapping Profile"} show={isShowProfileModal} onRequestClose={hideTvProfileModal}>
            <FormRow>
                <FormInput 
                    errorMessage = "Please enter TV Mapping Profile Name"
                    id = "tv_profile_name"
                    isError = {isTvProfileNameError}
                    title = "TV Mapping Profile Name"
                    onChangeValue = {(v) => {setTvProfileName(v); setIsTvProfileNameError(false)}}
                    value = {tvProfileName}
                />
            </FormRow>

            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={createOrUpdateTvProfile}/>
                <Button color="gray" label="Cancel" onClick={hideTvProfileModal}/>
            </div>
        </RightModal> 

        <RightModal title={modalAction === "edit" ? "Edit TV Channel Mapping" : "Add TV Channel Mapping"} show={isShowMappingModal} onRequestClose={hideMappingModal}>
            
            <FormRow>
                <label>TV Channel</label>
                <Select 
                    className={`${isSelectedTvChannelError ? "error" : ""}`}
                    classNamePrefix={`select`}
                    options={tvChannelsList.filter(it => it.channelSystemType === ChannelSystemType.User && !mappingsList.some(it2 => it2.name === it.name))} 
                    filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={onSelectedTvChannel}
                    value={selectedTvChannel}
                    isDisabled={modalAction === "edit"}
                />    
            </FormRow>

            <FormRow>
                <FormInput
                    errorMessage = {commandErrorMessage}
                    id = "command_value_input"
                    isError = {isCommandError}
                    title = "Command"
                    onChangeValue = {(e)=>{setCommand(e); setIsCommandError(false)}}
                    value = {command}
                />
                
            </FormRow>

            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={createOrUpdateTvChannelMapping}/>
                <Button color="gray" label="Cancel" onClick={hideMappingModal}/>
            </div>
        </RightModal>  

        <SmallModal show={isShowDeleteTvProfileModal} onRequestClose={hideDeleteTvProfileModal}> 
            <p>That you want to delete TV Mapping Profile?</p>
            <div className="modal-btn-group">
                <Button color="gray" label="Cancel" onClick={hideDeleteTvProfileModal}/>
                <Button color="green" label="Yes" onClick={removeTvProfile}/>
            </div>
        </SmallModal>

        <SmallModal show={isShowDeleteMappingModal} onRequestClose={hideDeleteMappingModal}> 
            <p>That you want to delete TV Channel Mapping?</p>
            <div className="modal-btn-group">
                <Button color="gray" label="Cancel" onClick={hideDeleteMappingModal}/>
                <Button color="green" label="Yes" onClick={removeMapping}/>
            </div>
        </SmallModal>

        <CenterModal title="SkyQ Commands" show={isShowSkyQCommandModal} onRequestClose={hideSkyQCommandModal}> 
            <div style={{display: "flex", flexDirection: "column", flexWrap: "wrap", maxHeight: 450, gap:15}}>
                {skyQCommands.map((it) => {
                    return <div style={{"fontSize": 20, fontWeight: 'bold'}}>{it}</div>
                })}
            </div>
        </CenterModal>
        
        <GlobalSpinner isShow={isLoading} />
    </>
}

export default TvChannelsMapping
